import { ofType } from 'redux-observable';
import { map, switchMap } from 'rxjs/operators';

import * as actions from '@redux/actions/spinAndWin';
import * as spinAndWinTypes from '@redux/actions/spinAndWin/spinAndWinTypes';
import { getAsObservable } from '@services/genericService';
import { deepCopy } from '@utils/utility';

import * as config from '../config';

export const getChanceToWinEpic = (action$) =>
  action$.pipe(
    ofType(spinAndWinTypes.GET_CHANCE_TO_WIN),
    switchMap((action) => {
      const params = {
        luckyDrawId: action.payload.luckyDrawId
      };

      return getAsObservable(config.ACTION_GET_CHANCE_TO_WIN, params).pipe(
        map((res) => {
          if (res.status === 200) {
            return actions.getChanceToWinSuccess(deepCopy(res?.data));
          } else {
            return actions.getChanceToWinFailed('Failed');
          }
        })
      );
    })
  );
